import UnicoUtils from "./script-utils.js";

/**
 * 商品一覧用コンポーネント
 * （絞り込み検索エリア + 一覧表示エリア）
 * ※絞り込みエリアの開閉等の制御
 */
export default class CollectionsArea extends HTMLElement {

  constructor() {
    super();

    // 各種要素の取得
    this.headerMenu = document.querySelector(".unico-header-content");
    this.searchArea = this.querySelector("[data-target-id=search-area]")
    this.openButton = this.querySelectorAll("[data-target-id=search-open-button]");
    this.closeButton = this.querySelector("[data-target-id=search-close-button]");

    // イベント登録
    this.initDrawerMenu();

    // 検索エリアのsticky制御
    document.addEventListener("DOMContentLoaded", () => this.initSearchArea());
    window.addEventListener("resize", () => this.initSearchArea());
    window.addEventListener("scroll", () => this.setSearchAreaHeight());
  }

  initSearchArea() {
    // 検索エリアの表示可能領域の高さを取得（ヘッダーの高さを引く）
    const viewportHeight = window.innerHeight - this.headerMenu.offsetHeight;

    // CSS変数の検索エリアの固定位置までの距離を取得
    const searchAreaDelta = getComputedStyle(this.searchArea).getPropertyValue("--search-area-delta").trim()
    const deltaValue = Number.isNaN(parseFloat(searchAreaDelta)) ? 0 : parseFloat(searchAreaDelta);

    // 検索エリアの高さを計算するために一時的にCSS変数の定義を削除
    this.searchArea.style.removeProperty("--search-area-delta");
    // 検索エリアの高さが表示領域に収まらなければ、固定表示用のクラスを付与
    if (this.searchArea.offsetHeight + deltaValue - 72 > viewportHeight) {
      this.searchArea.classList.add("-is-fixed");
    } else {
      this.searchArea.classList.remove("-is-fixed");
    }

    //　検索エリアの高さを画面内に収めるためカスタム変数をセット
    this.setSearchAreaHeight();
  }

  /**
   * ドロワーメニュー開閉のイベント登録
   */
  initDrawerMenu() {
    // 絞り込み検索エリアの開閉
    this.openButton.forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        this.searchArea.classList.add("-is-show");
      });
    });
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.searchArea.classList.remove("-is-show");
    });

    // コンポーネント外からの開閉要求を監視
    document.addEventListener("search-area-open", () => {
      this.searchArea.classList.add("-is-show");
    });
    document.addEventListener("search-area-close", () => {
      this.searchArea.classList.remove("-is-show");
    });

    // 画面外をクリックで検索エリアを閉じる（SPのみ）
    const searchArea = this.searchArea.querySelector(".unico-search")
    this.addEventListener("click", (e) => {
      if (UnicoUtils.isSP()) {
        if (this.searchArea.classList.contains("-is-show") && !searchArea.contains(e.target)) {
          this.searchArea.classList.remove("-is-show");
        }
      }
    }, true);
  }

  /**
   * 検索エリアの高さを画面内に収めるためカスタム変数をセット
   */
  setSearchAreaHeight() {
    const delta = this.searchArea.getBoundingClientRect().top;
    this.searchArea.style.setProperty("--search-area-delta", `${delta}px`);
  }
}
